//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'CaCorrection_Albumin',
  data() {
    return {
      form:{
        ca:'',
        alb:'',
      },
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        console.log(form)
        // Ca校正值=Ca（mg/dL）+0.8*[4-Alb（g/dL）]
        let result = form.ca + 0.8 * (4 - form.alb)
        self.hasScore = true
        return String(result.toFixed(1))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Renal/CaCorrection_Albumin.vue